import { useState, useEffect } from "react";
import Style from "./EnterpriseDetailsStyle";
import Spinner from "../../shared/Spinner/Spinner";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import { AxiosRequestConfig } from "axios";
import api from "../../services/api";
import PageTitle from "../../components/PageTitle";
import { InputImage } from "../../components/InputImage/InputImage";
import { GetFileFromURL } from "../../utils";
import InfoModal from "../../shared/Bootstrap/InfoModal";


export default function EnterprisesDetail(props) {

  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(true);
  const [showPopup, setShowPopup] = useState(false);
  const [urlImage, setUrlImage] = useState("");
  const [deleteImage, setDeleteImage] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [selectedImage, setSelectedImage] = useState({} as File);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  const enterpriseId = parseInt(props.match.params.enterpriseId) || 0;
  const creatingNew = enterpriseId <= 0;

  useEffect(() => {
    if (!creatingNew) {
      LoadEnterprise(enterpriseId);
    } else {
      setLoading(false);
    }
  }, []);

  async function LoadEnterprise(enterpriseId) {
    try {
      const result = await api.get(`/enterprises/${enterpriseId}`);
      if (result.data.success) {
        setName(result.data.name);
        setUrlImage(result.data.image);
        setAddress(result.data.address);
      }
    } catch (error: any) {
      setErrorMessage(error.response?.data?.message || "Não foi possível carregar o empreendimento.");
    }
    finally {
      setLoading(false);
    }
  }

  async function OnSubmit() {
    try {
      setLoading(true);
      const options: AxiosRequestConfig = {};
      const formData = new FormData();

      setLoading(true);
      if (selectedImage.name && !deleteImage) {
        formData.append("image", selectedImage, selectedImage.name);
      }

      formData.append("name", name);
      formData.append("address", address);
      if (!creatingNew) {
        formData.append("deleteImage", deleteImage ? "true" : "false");
      }
      await (creatingNew ?
        api.post(`/enterprises`, formData, options) :
        api.put(`/enterprises/${enterpriseId}`, formData, options));
      if (creatingNew) {
        goBack();
      } else {
        setUrlImage("")
        setShowSuccessPopup(true);
      }
    }
    catch (error: any) {
      setErrorMessage(error?.response?.data?.message);
    } finally {
      setLoading(false);
      onClosePopup();
    }
  }

  function onOpenPopUp() {
    setShowPopup(true);
  }
  function onClosePopup() {
    setShowPopup(false);
  }

  function onChangeFile(event) {
    setSelectedImage(event.target.files[0]);
    setDeleteImage(false)
  };
  function GetImageUrl(): string {
    return GetFileFromURL(urlImage, `${process.env.REACT_APP_BASE_URL}/enterprises/${enterpriseId}/image`);
  }
  function goBack() {
    props.history.goBack();
  }
  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Empreendimento editado com sucesso!"
        body="Suas edições foram salvas com sucesso!"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }
  return (
    <Style className="default-page">
      {ShowSuccessPopup()}
      <PageTitle title="Detalhes do empreendimento" />
      <div className="enterprise">
        <TwoButtonsModal
          show={showPopup}
          onHide={onClosePopup}
          loading={loading}
          title={creatingNew ? "Cadastrar empreendimento" : "Editar empreendimento"}
          body={"Você tem certeza que deseja" + (creatingNew ? " cadastrar este empreendimento?" : " editar este empreendimento?")}
          secondaryText="Fechar"
          secondaryOnClick={onClosePopup}
          secondaryDisabled={loading}
          primaryText="Confirmar"
          primaryOnClick={OnSubmit}
          primaryDisabled={loading}
        />
        <div>
          <button onClick={() => props.history.goBack()} className="btn btn-secondary return-button">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert alert-error">Erro: {errorMessage}</p>}
        <main className="default-main">
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault(); }}>
              <h2>{creatingNew ? "Criação" : "Edição"} de empreendimento</h2>
              <div>
                <label>Nome:</label>
                <input
                  disabled={loading}
                  defaultValue={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>
              <div>
                <label>Imagem:</label>
                <InputImage
                  id="file"
                  label=""
                  name="file"
                  alt="Imagem do produto"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetImageUrl()}
                  OnChange={onChangeFile}
                  OnRemove={() => setDeleteImage(true)}
                  image={selectedImage}
                />
              </div>
              <div>
                <label>Endereço:</label>
                <input
                  disabled={loading}
                  defaultValue={address}
                  onChange={e => setAddress(e.target.value)}
                />
              </div>

              <button
                className="btn btn-success btn-lg mt-4"
                type="button"
                disabled={name === ""}
                onClick={e => {
                  e.preventDefault();
                  onOpenPopUp();
                }}>{creatingNew ? "Cadastrar" : "Editar"}</button>
            </form>
          </div>
        </main>
      </div>
    </Style>
  )
}